import eventTypes from "@/events/event-types";
import store from "@/store";
import types from "@/store/types";
import { TweenLite } from "gsap";
var TopExperienceItem = /** @class */ (function () {
    function TopExperienceItem(el) {
        console.log("[create] TopExperienceItem");
        this._el = el;
    }
    TopExperienceItem.prototype.setup = function () {
        var _this = this;
        this._labelElem = this._el.querySelector(".top-experience__label");
        this._contentElem = this._el.querySelector(".top-experience__content");
        this._descriptionElem = this._el.querySelector(".top-experience__description");
        this._speed = -0.002;
        this._radian = Number(this._el.dataset.radian);
        this._isFore = false;
        this._tempZIndex = -1;
        this._tick = function () {
            if (!store.state.isHoverAtTopExperienceItem) {
                _this._radian += _this._speed;
                var sin = Math.sin(_this._radian);
                TweenLite.set(_this._el, {
                    x: 290 * Math.cos(_this._radian),
                    y: 160 * sin,
                });
                if (0.99 < sin) {
                    if (!_this._isFore) {
                        TweenLite.set(_this._el, {
                            zIndex: ++TopExperienceItem.CURRENT_Z_INDEX,
                        });
                        _this._isFore = true;
                    }
                }
                else if (sin < -0.99) {
                    if (_this._isFore) {
                        _this._isFore = false;
                    }
                }
            }
            requestAnimationFrame(_this._tick);
        };
        requestAnimationFrame(this._tick);
        this._setNativeEvents();
    };
    TopExperienceItem.prototype.teardown = function () {
        this._clearNativeEvents();
        delete this._el;
    };
    TopExperienceItem.prototype._setNativeEvents = function () {
        var _this = this;
        this._onMouseEnter = function () {
            var labelElemHeight = _this._labelElem
                ? _this._labelElem.clientHeight
                : 0;
            TweenLite.to(_this._contentElem, 0.6, {
                height: _this._descriptionElem.clientHeight + labelElemHeight,
            });
            _this._tempZIndex = Number(_this._el.style.zIndex);
            TweenLite.set(_this._el, { zIndex: 99999 });
            _this._el.classList.add("is-description-open");
            store.commit(types.ENTER_TOP_EXPERIENCE_ITEM);
        };
        this._onMouseLeave = function () {
            TweenLite.to(_this._contentElem, 0.2, {
                height: 18,
            });
            TweenLite.set(_this._el, {
                zIndex: _this._tempZIndex,
            });
            _this._el.classList.remove("is-description-open");
            store.commit(types.LEAVE_TOP_EXPERIENCE_ITEM);
        };
        this._el.addEventListener(eventTypes.MOUSE_ENTER, this._onMouseEnter);
        this._el.addEventListener(eventTypes.MOUSE_LEAVE, this._onMouseLeave);
    };
    TopExperienceItem.prototype._clearNativeEvents = function () {
        this._el.removeEventListener(eventTypes.MOUSE_ENTER, this._onMouseEnter);
        this._el.removeEventListener(eventTypes.MOUSE_LEAVE, this._onMouseLeave);
    };
    TopExperienceItem.CURRENT_Z_INDEX = 5;
    return TopExperienceItem;
}());
export default TopExperienceItem;
